import React from "react";
import "../../../../styles/styles.css";
import Navbar from "../../../Navbar/Navbar";

const Header = () => {
  return (
    <div className="header">
      <Navbar></Navbar>
    </div>
  );
};
export default Header;
